module.exports = __webpack_public_path__ + "img/logo-blue.8eb27182.png";